import { HttpTimeoutError } from '@cian/peperrors';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { ASYNC_STATUS } from '@/packages/typesafe-result';

import { prepareHighwayDirectionss } from '@/microfrontends/filters/shared/mappers/prepareHighwayDirections';

import { MOSCOW_REGION_ID } from '../../../constants/regions';
import { fetchDirectionsSafe } from '../../../services/fetchHighwaysSafe';
import { type IHighwayDirection } from '../../../types/highways';
import { highwaysSelector } from '../../slices/highways/selectors';
import { type TThunkApi } from '../../types';

export const requestHighways = createAsyncThunk<IHighwayDirection[], number, TThunkApi>(
  'highways/request',
  async (regionId, thunkApi) => {
    const { rejectWithValue, extra: ctx } = thunkApi;
    const result = await fetchDirectionsSafe(
      ctx,
      { regionId: regionId === 1 ? MOSCOW_REGION_ID : regionId },
      { subdomain: ctx.custom.subdomain },
    );

    if (result.isErr()) {
      ctx.logger[result.isErrAnd(HttpTimeoutError.is) ? 'warning' : 'error'](result.Err);
    }

    return result.map(prepareHighwayDirectionss).unwrapOrElse(rejectWithValue);
  },
  {
    condition: (regionId, { getState }) => {
      const state = getState();
      const highwaysState = highwaysSelector(state);

      const regionHighways = highwaysState[regionId];

      return (
        regionHighways &&
        !(
          regionHighways?.status === ASYNC_STATUS.PENDING ||
          (regionHighways?.status === ASYNC_STATUS.SUCCESS && regionHighways?.data.length > 0)
        )
      );
    },
  },
);
